import React from 'react';

const Navbar = ({ items, className, separatorClassName, itemClassName }) => {
  return (
    <div className={className}>
      {items.map((text, index) => (
        <React.Fragment key={index}>
          <a className={itemClassName} href="#">{text}</a>
          {index < items.length - 1 && (
            <>
              <span className={separatorClassName}>|</span><wbr />
            </>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Navbar;
